/**
 * @description
 * Objeto typefinders
 */

export class Typefinders {
    public id:number = null;
    public code:string = "";
    public desc:string;
    public online:number = null;

    constructor() {}
  
}